module.exports = {
      id: "whatsapp-usage",
      viewBox: "0 0 135.081 135.08",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#whatsapp",
      toString: function () {
        return this.url;
      }
    }